<template>
  <div
    v-if="isNative && (pendingCount > 0 || isSyncing)"
    class="sync-badge-wrapper"
    @click="handleClick"
    title="Operaciones pendientes de sincronizar"
  >
    <!-- Icono de nube (SVG inline) -->
    <svg
      class="sync-cloud-icon"
      :class="{ 'is-syncing': isSyncing, 'is-offline': !isOnline }"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path
        d="M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
      />
    </svg>

    <!-- Badge con el número de pendientes -->
    <span v-if="!isSyncing && pendingCount > 0" class="sync-badge">
      {{ pendingCount > 99 ? "99+" : pendingCount }}
    </span>

    <!-- Animación de sincronizando -->
    <span v-if="isSyncing" class="sync-spinner">↻</span>
  </div>
</template>

<script>
import { forceSync, refreshPendingCount, syncState } from "@/stores/syncStore";
import { Capacitor } from "@capacitor/core";

export default {
  name: "SyncBadge",
  computed: {
    isNative() {
      return Capacitor.isNativePlatform();
    },
    pendingCount() {
      return syncState.pendingCount;
    },
    isSyncing() {
      return syncState.isSyncing;
    },
    isOnline() {
      return this.$networkState.isOnline;
    },
  },
  methods: {
    async handleClick() {
      if (this.isOnline && !this.isSyncing) {
        await forceSync();
      }
    },
  },
  mounted() {
    refreshPendingCount();
    this._queueListener = () => refreshPendingCount();
    window.addEventListener("offline-queue-changed", this._queueListener);
  },
  beforeDestroy() {
    window.removeEventListener("offline-queue-changed", this._queueListener);
  },
};
</script>

<style scoped>
.sync-badge-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.sync-cloud-icon {
  width: 28px;
  height: 28px;
  color: #718096; /* gris neutro cuando online y con pendientes */
  transition: color 0.3s ease;
}

/* Sin conexión → rojo */
.sync-cloud-icon.is-offline {
  color: #e53e3e;
}

/* Sincronizando → verde */
.sync-cloud-icon.is-syncing {
  color: #38a169;
}

/* Badge rojo con el número */
.sync-badge {
  position: absolute;
  top: -2px;
  right: -4px;
  background-color: #e53e3e;
  color: white;
  font-size: 9px;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  line-height: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

/* Spinner de sincronización */
.sync-spinner {
  position: absolute;
  top: -2px;
  right: -4px;
  font-size: 14px;
  color: #38a169;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
